import { useGetDefaultTenantTimeRange } from '@modules/common/hooks';
import { TimeUnit } from 'generated/graphql';
import stringify from 'json-stable-stringify';
import { ReactNode, useMemo } from 'react';
import { v5 } from 'uuid';
import { TimeRange } from 'v2/core/entities';
import { FieldName, SourceNameWithNamespace } from 'v2/core/entities/fields';
import { QueryContainer } from 'v2/core/services/notebook/types';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';

// ref: https://www.sohamkamani.com/uuid-versions-explained/#v5-non-random-uuids
const namespace = '1b671a64-40d5-491e-99b0-da01ff1f3341';

export const GenerateWidgetUUID = (
  query: QueryContainer,
  groupByKey: string,
) => {
  // Why not use JSON.stringify?
  // JSON.stringify doesn't order fields and can lead to different strings and
  // thus uuids
  // stringify returns deterministic json string everytime
  return v5(stringify(query) + stringify(groupByKey), namespace);
};

export type WidgetOption = {
  label: string;
  value: string;
  alreadyAdded: boolean;
  fieldName: FieldName;
  source: SourceNameWithNamespace;
  sourceName: string;
  icon?: ReactNode;
  sublabel?: string;
};

export type MetadataOption = {
  label: string;
  source: SourceNameWithNamespace;
  options: WidgetOption[];
  alreadyAdded?: boolean;
  fieldName?: FieldName;
  value: string;
};

export const useGetDefaultQueryContainer = (): QueryContainer => {
  const defaultTimeRange = useGetDefaultTenantTimeRange();

  const queryContainer = useMemo((): QueryContainer => {
    return {
      WhereClause: EmptyWhereClause,
      DateRange: defaultTimeRange as TimeRange,
      AggregatePeriod: TimeUnit.Month,
    };
  }, [defaultTimeRange]);

  return queryContainer;
};
